import { render } from "./ReviewFeedBackModal.vue?vue&type=template&id=0d1d0376&scoped=true"
import script from "./ReviewFeedBackModal.vue?vue&type=script&lang=js"
export * from "./ReviewFeedBackModal.vue?vue&type=script&lang=js"

import "./ReviewFeedBackModal.vue?vue&type=style&index=0&id=0d1d0376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1d0376"]])

export default __exports__